import { render } from "./MainPageClientSwiper.vue?vue&type=template&id=6ed96b90&scoped=true"
import script from "./MainPageClientSwiper.vue?vue&type=script&lang=js"
export * from "./MainPageClientSwiper.vue?vue&type=script&lang=js"

import "./MainPageClientSwiper.vue?vue&type=style&index=0&id=6ed96b90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed96b90"]])

export default __exports__